import BaseComponent from '../abstracts/BaseComponent';

export default class NewBrandsComponent extends BaseComponent {

  constructor(element) {
    super(element);

    this.$el.querySelectorAll('img').forEach(item => {
      item.addEventListener('lazyloaded', () => {
        // console.log('lazyloaded')
        if (item.complete && (typeof item.naturalWidth !== 'undefined') && (item.naturalWidth > 0)) {
          return;
        }
        item.addEventListener('error', () => {
          // console.log('error');
          // item.outerHTML = '<div>' + item.alt + '</div>';
          item.src = window.fair.smallLogo;
        })
        item.src = item.src.replace(/\/resolutions\/res-l100x100\//, '/original/');
      });
    });
  }
}
